import type { CapacityManagementRootResponse } from 'src/apis/capacity-management/types';
import { useOptionalCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import type { OrganisationRole } from 'src/apis/monolith/types';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

export function canAccessCompanyTransactions(
  root: CapacityManagementRootResponse | undefined,
  role: OrganisationRole | undefined
): boolean {
  return (
    !!root?.companyTransactions &&
    role === 'SHIPPER' &&
    !!(root._links?.myTransactions ?? root._links?.myTransactionsV3)
  );
}

export type CompanyTransactionsAccess =
  | { loaded: false }
  | { loaded: true; canAccess: boolean };

export function useCompanyTransactionsAccess(): CompanyTransactionsAccess {
  const capacityManagementRoot = useOptionalCapacityManagementRoot();
  const monolithUser = useOptionalAuthenticatedMonolithUser();

  if (!capacityManagementRoot.loaded) return { loaded: false };

  return {
    loaded: true,
    canAccess: canAccessCompanyTransactions(
      capacityManagementRoot.response?.data,
      monolithUser?.currentlyActingWithOrganisationRole
    ),
  };
}
